import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import saveAs from 'file-saver';
import { Table } from 'primeng/table';
import {
  ProgramTypesGUID,
  ProgramTypes,
  PaymentBatchStatus
} from '../../../models/_enum-collections';
import { ApiResponse } from '../../../models/api-response.model';
import { EventDownloadPaymentScheduleCSV } from '../../../models/event-download-payment-schedule-csv.model';
import { EventPaymentBatchDetails } from '../../../models/event-payment-batch-details.model';
import { EventPaymentBatchEvent } from '../../../models/event-payment-batch-event.model';
import { EventPaymentBatchStatusDropDown } from '../../../models/event-payment-batch-status.model';
import { AppConstants } from '../../common/app-constants';
import { CommonService } from '../../common/common.service';
import { SettingsService } from '../../common/settings.service';
import { EventPaymentScheduleService } from '../../services/event-payment-schedule.service';
import { WorkshopCodeService } from '../../services/workshop-code.service';
import { CommonSharedModule } from '../../common/shared.module';
import eventNewPaymentBatch from '../event-new-payment-batch-milestone2/event-new-payment-batch-milestone2.component-config.json';

@Component({
  selector: 'app-event-edit-payment-batch',
  templateUrl: './event-edit-payment-batch.component.html',
  styleUrls: ['./event-edit-payment-batch.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class EventEditPaymentBatchComponent implements OnInit {
  @ViewChild('dt', { static: false }) dt!: Table;
  pbName!: string;
  editPaymentBatchForm!: FormGroup;
  eventPaymentBatchScheduleId!: number;
  engcols!: any[];
  apires!: ApiResponse;
  msgs: any[] = [];
  collecteIdArray: any[] = [];
  collecteId!: string;
  paymentBatchEvents!: EventPaymentBatchEvent[];
  copyOfpaymentBatchEvents!: EventPaymentBatchEvent[];
  paymentBatchStatus: EventPaymentBatchStatusDropDown[] = [];
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;
  currentPageInfo!: string;
  totalRecords!: number;
  tblPageNumber!: number;
  marked = false;
  updatePaymentBatch!: EventPaymentBatchDetails;
  selectedEvents!: EventPaymentBatchEvent[];
  cancelledPaymentBatchEvents!: EventPaymentBatchEvent[];
  clonedEvents: Record<number, EventPaymentBatchEvent> = {};
  editing = false;
  editingHeaderCheck = false;
  editingNav = false;
  check = false;
  showForm = true;
  disableSubmit = false;
  isSpin = false;
  isSpinEx = false;
  downloadCSV: EventDownloadPaymentScheduleCSV[] = [];
  copyAssociatedEvents!: EventPaymentBatchEvent[];
  editedRowEventIds: number[] = [];
  addedRowEventIds: number[] = [];
  deletedRowEventIds: number[] = [];
  firstEditInitEng!: EventPaymentBatchEvent;
  editRowsCtr = 0;
  isShowOnlyAssoctd = true;
  isDataLoading = false;
  loading = false;
  loadingIcon = 'fa-circle-o-notch';
  showTargetProduct = false;
  selectedProgramOption!: string;
  selectedProgramGuid!: ProgramTypesGUID;
  engagementId!: string;
  engagementName!: string;
  engagementSubType!: string;
  isMRPP!: boolean;
  programTypeId!: number;
  isPaid!: boolean;
  warningMessage =
    'Event Keys will be removed from the batch. Do you wish to continue?';
  isBatchEventsDeletedConfirmation = false;
  isSubmit = false;

  constructor(
    private eventPaymentScheduleService: EventPaymentScheduleService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    public settings: SettingsService,
    public http: HttpClient,
    public workshopcodeService: WorkshopCodeService
  ) {}

  ngOnInit() {
    this.selectedProgramOption = history.state.selectedProgramOption;
    this.getEventSheduleHeaderFilelds();
    this.isMRPP =
      history.state.programTypeGuid == ProgramTypesGUID.MRPP ? true : false;
    this.programTypeId = this.isMRPP ? ProgramTypes.MRPP : ProgramTypes.Events;
    this.loading = true;
    this.pbName = this.route.snapshot.paramMap.get('pbName') || '';
    this.editing = false;
    this.editingHeaderCheck = false;
    this.dataViewRecsPerPage = 15; // AppConstants.dataListRecsPerPage;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;

    this.engcols = [
      { field: 'eventId', header: 'Event ID' },
      { field: 'eventName', header: 'Event Name' },
      { field: 'eventType', header: 'Event Type' },
      { field: 'eventTargetProductName', header: 'Target Product' },
      { field: 'partnerName', header: 'Partner Name' },
      { field: 'payeeId', header: 'Payee Id' },
      { field: 'profileStatus', header: 'Profile Status' },
      { field: 'partnerPriority', header: 'Partner Priority' },
      { field: 'blockedStatus', header: 'Blocked Status' },
      { field: 'partnerLocation', header: 'Partner Location' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'partnerId', header: 'Partner ID' },
      { field: 'payeeName', header: 'Payee Name' },
      { field: 'amount', header: 'Amount' },
      { field: 'msInvoiceNumber', header: 'MS Invoice Number' },
      { field: 'msInvoicePaidDate', header: 'MS Invoice Paid Date' },
      {
        field: 'paymentCentralTransactionId',
        header: 'Payment Central Transaction ID'
      }
    ];

    this.getPaymentBatchStatus();

    this.editPaymentBatchForm = this.formBuilder.group({
      paymentBatchName: [''],
      paymentBatchScheduleDate: ['', [Validators.required]],
      anticipatedPaymentDate: ['', [Validators.required]],
      actualPaymentCentralDate: [''],
      paymentBatchStatus: ['', [Validators.required]],
      selectedEvents: [''],
      amount: [''],
      partnerId: [''],
      payeeName: [''],
      contactName: [''],
      contactEmail: [''],
      emailLanguage: [''],
      accountCode: [''],
      internalOrderOrCostCenter: [''],
      currency: [''],
      netAmount: [''],
      taxAmount: [''],
      msInvoiceNumber: [''],
      msInvoicePaidDate: [''],
      paymentCentralRequestId: ['']
    });

    this.getPaymentBatchDetails(this.pbName, this.programTypeId);
  }

  downloadExportCSV() {
    this.isSpinEx = true;
    const selectedEventIds = this.selectedEvents.map(function (v) {
      return v.eventId;
    });
    if (this.selectedProgramOption == 'Events') {
      this.downloadExportAttendeeCSV(selectedEventIds);
    }
    this.downloadExportPoeCSV();
    this.downloadExportPoeDocuments();
  }

  downloadExportPoeCSV() {
    this.isSpinEx = true;
    const selectedID = this.selectedEvents;
    this.eventPaymentScheduleService
      .downloadExportPoeCSV(selectedID)
      .subscribe(downloadFile => {
        this.isSpinEx = false;
        const file = new Blob([downloadFile], {
          type: 'application/octet-stream'
        });
        saveAs(
          file,
          this.editPaymentBatchForm.controls['paymentBatchName'].value +
            '-Survey' +
            '.zip'
        );
      });
  }

  downloadExportPoeDocuments() {
    this.isSpinEx = true;
    const selectedID = this.selectedEvents;
    this.eventPaymentScheduleService
      .downloadExportPoeDocuments(selectedID)
      .subscribe(downloadFile => {
        this.isSpinEx = false;
        const file = new Blob([downloadFile], {
          type: 'application/octet-stream'
        });
        saveAs(
          file,
          this.editPaymentBatchForm.controls['paymentBatchName'].value + '.zip'
        );
      });
  }

  downloadExportAttendeeCSV(selectedEventIds) {
    this.isSpinEx = true;
    this.eventPaymentScheduleService
      .createAttendeeCSV(
        selectedEventIds,
        this.editPaymentBatchForm.controls['paymentBatchName'].value
      )
      .subscribe(downloadFile => {
        this.isSpinEx = false;
        const file = new Blob([downloadFile], {
          type: 'application/octet-stream'
        });
        saveAs(
          file,
          this.editPaymentBatchForm.controls['paymentBatchName'].value +
            '-Attendee' +
            '.zip'
        );
      });
  }

  exportCSV() {
    const exportData = this.selectedEvents.map(exportEvent => {
      return {
        TransactionId:
          exportEvent.eventId +
          '_' +
          this.workshopcodeService.getEventWorkshopCode(
            exportEvent.eventName || ''
          ),
        PayeeName: exportEvent.payeeName,
        PayeeId: exportEvent.payeeId,
        ContactName: exportEvent.contactName,
        ContactEmail: exportEvent.contactEmail,
        EmailLanguage: exportEvent.emailLanguage,
        AccountCode: exportEvent.accountCode,
        InternalOrderOrCostCenter: exportEvent.internalOrderOrCostCenter,
        Currency: exportEvent.currency,
        NetAmount: exportEvent.netAmount,
        TaxAmount: exportEvent.taxAmount
      };
    });
    const replacer = (key, value) => (value === null ? '' : value);
    const header = Object.keys(exportData[0]);
    const csv = exportData.map(row =>
      header
        .map(fieldName => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const blob = new Blob([csvArray], { type: 'text/csv' });
    saveAs(blob, this.pbName + '.csv');
  }

  setMessage(msg: any, severity: string, noReset?: boolean) {
    if (!noReset) {
      this.msgs = [];
    }
    this.msgs.push({ severity: severity || 'error', detail: msg });
  }

  isEventInAssociated(eventID: number) {
    return this.copyAssociatedEvents.some(e => e.eventId === eventID);
  }

  getPaymentBatchDetails(pbName: string, programTypeId: number): void {
    this.eventPaymentScheduleService
      .getPaymentBatchEventDetails(pbName, programTypeId)
      .subscribe(paymentBatchDetails => {
        this.pbName = pbName;
        if (
          paymentBatchDetails.paymentScheduleBatch?.paymentBatchStatusId ==
          PaymentBatchStatus.Paid
        ) {
          this.isPaid = true;
        }
        this.eventPaymentBatchScheduleId =
          paymentBatchDetails.paymentScheduleBatch
            ?.eventPaymentBatchScheduleId || -1;
        this.editPaymentBatchForm.controls['paymentBatchStatus'].patchValue({
          eventPaymentBatchStatusId:
            paymentBatchDetails.paymentScheduleBatch?.paymentBatchStatusId,
          eventPaymentBatchStatus:
            paymentBatchDetails.paymentScheduleBatch?.paymentBatchStatus
        });

        const datePipe = new DatePipe('en-US');
        const epaymentBatchScheduleDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch?.paymentBatchScheduleDate,
          'MM/dd/yyyy'
        );
        const eanticipatedPaymentDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch?.anticipatedPaymentDate,
          'MM/dd/yyyy'
        );
        const eactualPaymentCentralDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch?.actualPaymentCentralDate,
          'MM/dd/yyyy'
        );

        this.editPaymentBatchForm.patchValue({
          paymentBatchName:
            paymentBatchDetails.paymentScheduleBatch?.paymentBatchName,
          paymentBatchScheduleDate: epaymentBatchScheduleDate,
          anticipatedPaymentDate: eanticipatedPaymentDate,
          actualPaymentCentralDate: eactualPaymentCentralDate,
          paymentCentralRequestId:
            paymentBatchDetails.paymentScheduleBatch?.paymentCentralRequestId
        });

        this.copyOfpaymentBatchEvents = paymentBatchDetails.events;
        this.paymentBatchEvents = paymentBatchDetails.events
          .map(e => {
            return { ...e, editCheckBox: false };
          })
          .filter(e => e.associated === 1);
        this.selectedEvents = this.paymentBatchEvents.filter(x => x.associated);
        this.copyAssociatedEvents = this.selectedEvents;

        this.onAddNewEvents(true);
        this.loading = false;
      });
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    if (this.isShowOnlyAssoctd) {
      if (this.dt) {
        this.dt.filter(1, 'associated', 'equals');
      }

      if (
        this.paymentBatchEvents === null ||
        this.paymentBatchEvents.length === 0
      ) {
        this.totalRecords = 0;
        this.currentPageInfo = 'No Records Found';
      } else {
        if (this.dt) {
          this.dt.sortField = 'eventID';
          this.dt.sortOrder = -1;
          this.dt.reset();
          this.dt.filter(1, 'associated', 'equals');
        }
        this.totalRecords = this.paymentBatchEvents.length;

        if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
      }
    } else {
      if (this.dt) {
        this.dt.sortField = 'eventID';
        this.dt.sortOrder = -1;
        this.dt.reset();
      }

      if (
        this.paymentBatchEvents === null ||
        this.paymentBatchEvents.length === 0
      ) {
        this.totalRecords = 0;
        this.currentPageInfo = 'No Records Found';
      } else {
        this.paymentBatchEvents.forEach(event => {
          if (!event.associated) {
            event.editCheckBox = false;
          }
        });
        this.selectedEvents = this.paymentBatchEvents.filter(x => x.associated);
        this.totalRecords = this.paymentBatchEvents.length;
        if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
      }
    }
  }

  selectRow(e, l) {
    const paymentBatchEvent = this.paymentBatchEvents.find(
      item => item.eventId === l.eventId
    );

    if (paymentBatchEvent) {
      if (e === true) {
        paymentBatchEvent.editCheckBox = true;
      } else {
        paymentBatchEvent.editCheckBox = false;
      }
    }
  }

  getPaymentBatchStatus() {
    this.eventPaymentScheduleService
      .getPaymentBatchStatus()
      .subscribe(engList => {
        this.paymentBatchStatus = engList;
      });
  }

  onSubmit() {
    this.loading = true;
    const navigationExtras: NavigationExtras = {
      state: {
        selectedProgramOption: this.selectedProgramOption
      }
    };

    const actualPaymentCentralDate =
      this.editPaymentBatchForm.controls['actualPaymentCentralDate'].value;

    this.updatePaymentBatch = {
      events: [],
      paymentScheduleBatch: {
        eventPaymentBatchScheduleId: this.eventPaymentBatchScheduleId,
        paymentBatchScheduleDate: this.getDate(
          new Date(
            this.editPaymentBatchForm.controls['paymentBatchScheduleDate'].value
          )
        ).toISOString(),
        anticipatedPaymentDate: this.getDate(
          new Date(
            this.editPaymentBatchForm.controls['anticipatedPaymentDate'].value
          )
        ).toISOString(),
        actualPaymentCentralDate:
          actualPaymentCentralDate
            ? this.getDate(new Date(actualPaymentCentralDate)).toISOString()
            : null,
        paymentBatchStatusId:
          this.editPaymentBatchForm.controls['paymentBatchStatus'].value
            .eventPaymentBatchStatusId,
        paymentBatchName:
          this.editPaymentBatchForm.controls['paymentBatchName'].value,
        paymentCentralRequestId:
          this.editPaymentBatchForm.controls['paymentCentralRequestId'].value
      }
    };

    if (
      this.updatePaymentBatch.paymentScheduleBatch?.paymentBatchStatusId ===
      PaymentBatchStatus.Cancelled
    ) {
      this.cancelledPaymentBatchEvents = this.selectedEvents;
      this.selectedEvents = [];
    } else {
      this.cancelledPaymentBatchEvents = [];
    }
    if (
      this.selectedEvents.length !== 0 ||
      this.selectedEvents.length !== undefined ||
      this.updatePaymentBatch.paymentScheduleBatch?.paymentBatchStatusId ===
        PaymentBatchStatus.Cancelled
    ) {
      for (const item of this.selectedEvents) {
        this.updatePaymentBatch.events.push({
          eventId: item.eventId,
          eventName: item.eventName,
          partnerId: item.partnerId,
          payeeName: item.payeeName,
          contactName: item.contactName,
          contactEmail: item.contactEmail,
          emailLanguage: item.emailLanguage,
          accountCode: item.accountCode,
          internalOrderOrCostCenter: item.internalOrderOrCostCenter,
          currency: item.currency,
          amount: item.amount,
          netAmount: item.netAmount,
          taxAmount: item.taxAmount,
          msInvoiceNumber: item.msInvoiceNumber,
          msInvoicePaidDate: item.msInvoicePaidDate,
          paymentCentralTransactionId: item.paymentCentralTransactionId
        });
        const mn = this.paymentBatchEvents.find(
          it => it.eventId === item.eventId
        );
        const msin = mn?.msInvoiceNumber;
        if (msin !== item.msInvoiceNumber) {
          this.collecteIdArray.push(mn?.eventId);
        }
      }
    }

    if (
      this.selectedEvents.length === 0 &&
      this.updatePaymentBatch.paymentScheduleBatch?.paymentBatchStatusId !==
        PaymentBatchStatus.Cancelled
    ) {
      this.loading = false;
      this.msgs = [];
      this.msgs.push({
        severity: 'error',
        detail: 'Please select any one Event from the list'
      });
      setTimeout(() => {
        this.msgs = [];
      }, 5000);
      return;
    }
    const initialEventKeys = this.copyAssociatedEvents.map(m => m.eventId);
    const currentEventKeys = this.selectedEvents.map(m => m.eventId);
    const eventKeysUnchecked = initialEventKeys.filter(
      item => !currentEventKeys.includes(item)
    );
    const removedEventKeys = [...new Set(eventKeysUnchecked)];
    if (!this.isMRPP && !this.isSubmit) {
      this.loading = false;
      if (
        removedEventKeys.length > 0 &&
        this.editPaymentBatchForm.controls['paymentBatchStatus'].value
          .eventPaymentBatchStatusId !== PaymentBatchStatus.Cancelled
      ) {
        this.isBatchEventsDeletedConfirmation = true;
        this.warningMessage =
          (removedEventKeys.length === 1 ? 'Event Key' : 'Event Keys') +
          ': ' +
          removedEventKeys.join(', ') +
          ' will be removed from the batch. Do you wish to continue?';
        return;
      }
    } else if (this.isMRPP && !this.isSubmit) {
      if (
        removedEventKeys.length > 0 &&
        this.editPaymentBatchForm.controls['paymentBatchStatus'].value
          .eventPaymentBatchStatusId !== PaymentBatchStatus.Cancelled
      ) {
        this.loading = false;
        this.isBatchEventsDeletedConfirmation = true;
        this.warningMessage =
          (removedEventKeys.length === 1 ? 'Engagement ID' : 'Engagement IDs') +
          ': ' +
          removedEventKeys.join(', ') +
          ' will be removed from the batch. Do you wish to continue?';
        return;
      }
    }

    this.updatePaymentBatch.programTypeGuid = this.getProgramTypeGuid();
    this.eventPaymentScheduleService
      .updatePaymentBatch(this.updatePaymentBatch)
      .subscribe(
        messageResponse => {
          this.apires = messageResponse;
          this.loading = false;
          this.setMessage('Payment Batch Updated Successfully', 'success');
          this.editPaymentBatchForm.reset();
          this.selectedEvents = [];
          this.showForm = false;

          if (
            this.cancelledPaymentBatchEvents.length !== 0 &&
            this.cancelledPaymentBatchEvents.length !== undefined &&
            this.updatePaymentBatch.paymentScheduleBatch
              ?.paymentBatchStatusId === PaymentBatchStatus.Cancelled
          ) {
            const canceledPaymentBatch = {
              events: this.cancelledPaymentBatchEvents,
              programTypeGuid: this.getProgramTypeGuid()
            };

            this.eventPaymentScheduleService
              .UpdateCancelledPaymentBatchEventDetails(canceledPaymentBatch)
              .subscribe(
                () => {
                  this.loading = false;
                  this.showForm = false;
                  setTimeout(() => {
                    this.router.navigate(
                      ['events-payment-schedule'],
                      navigationExtras
                    );
                  }, 2000);
                },
                error => {
                  this.loading = false;
                  this.showForm = true;
                  let errors: string[] = [];
                  const paymentRequestIDWarningMessage =
                    'Payment Central RequestID is already exists.';
                  if (error.status === 400) {
                    errors = this.commonService.getBadRequestErrors(error);
                    for (const msg of errors) {
                      this.setMessage(msg, 'warn', true);
                    }
                  } else if (error.error === paymentRequestIDWarningMessage) {
                    this.setMessage(paymentRequestIDWarningMessage, 'warn');
                  } else {
                    this.setMessage(
                      'Sorry an Error Occurred while Creating Payment Batch',
                      'warn'
                    );
                  }
                }
              );
          } else {
            this.loading = false;
            this.showForm = false;
            setTimeout(() => {
              this.router.navigate(
                ['events-payment-schedule'],
                navigationExtras
              );
            }, 2000);
          }
        },
        error => {
          let errors: string[] = [];
          const paymentRequestIDWarningMessage =
            'Payment Central RequestID is already exists.';
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.setMessage(msg, 'warn', true);
            }
          } else if (error.error === paymentRequestIDWarningMessage) {
            this.setMessage(paymentRequestIDWarningMessage, 'warn');
          } else {
            this.setMessage(
              'Sorry an Error Occurred while Creating Payment Batch',
              'warn'
            );
          }
        }
      );
  }

  onRowEditInit(eng: EventPaymentBatchEvent) {
    const eventId = eng.eventId as number;
    eng.editCheckBox = true;
    this.clonedEvents[eventId] = { ...eng };

    if (this.editRowsCtr === 0) {
      this.editingHeaderCheck = true;
      this.firstEditInitEng = Object.create(eng);
    }
    this.editRowsCtr++;
    this.disableSubmit = true;
  }

  onRowEditSave(eng: EventPaymentBatchEvent) {
    if (this.firstEditInitEng.amount !== null) {
      const eventId = eng.eventId as number;
      delete this.clonedEvents[eventId];
      eng.partnerId = this.firstEditInitEng.partnerId;
      eng.payeeName = this.firstEditInitEng.payeeName;
      eng.contactName = this.firstEditInitEng.contactName;
      eng.contactEmail = this.firstEditInitEng.contactEmail;
      eng.emailLanguage = this.firstEditInitEng.emailLanguage;
      eng.accountCode = this.firstEditInitEng.accountCode;
      eng.internalOrderOrCostCenter =
        this.firstEditInitEng.internalOrderOrCostCenter;
      eng.currency = this.firstEditInitEng.currency;
      eng.amount = this.firstEditInitEng.amount;
      eng.netAmount = this.firstEditInitEng.netAmount;
      eng.taxAmount = this.firstEditInitEng.taxAmount;
      eng.msInvoiceNumber = this.firstEditInitEng.msInvoiceNumber;
      eng.msInvoicePaidDate = this.firstEditInitEng.msInvoicePaidDate;
      eng.paymentCentralTransactionId =
        this.firstEditInitEng.paymentCentralTransactionId;
      eng.edited = true;
      this.editRowsCtr--;
    }
    if (this.editRowsCtr === 0) {
      this.editingHeaderCheck = false;
    }
    this.disableSubmit = false;
  }

  onRowEditCancel(eng: EventPaymentBatchEvent, index: number) {
    this.paymentBatchEvents[index] = this.clonedEvents[eng.eventId || -1];
    delete this.clonedEvents[eng.eventId || -1];
    const idx = this.selectedEvents.findIndex(e => e.eventId === eng.eventId);
    this.selectedEvents.splice(idx, 1);
    this.onAddNewEvents(this.isShowOnlyAssoctd);
    this.paymentBatchEvents[index].editCheckBox = false;
    this.editing = false;
    this.editRowsCtr--;
    if (this.editRowsCtr === 0) {
      this.editingHeaderCheck = false;
    }
    this.disableSubmit = false;
  }

  cancelSearchNav() {
    const navigationExtras: NavigationExtras = {
      state: {
        selectedProgramOption: this.selectedProgramOption
      }
    };
    this.router.navigate(['events-payment-schedule'], navigationExtras);
  }

  onAddNewEvents(val) {
    this.isShowOnlyAssoctd = val;
    if (this.isShowOnlyAssoctd) {
      if (this.dt) {
        this.dt.filter(1, 'associated', 'equals');
      }

      this.totalRecords = this.paymentBatchEvents.filter(
        e => e.associated === 1
      ).length;

      this.currentPageInfo =
        'Showing 1 - ' +
        this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      const uniqEventIds = new Set(this.paymentBatchEvents.map(d => d.eventId));

      this.paymentBatchEvents = [
        ...this.paymentBatchEvents,
        ...this.copyOfpaymentBatchEvents.filter(
          d => !uniqEventIds.has(d.eventId)
        )
      ];

      if (this.dt) {
        this.dt.reset();
      }

      this.totalRecords = this.paymentBatchEvents.length;
      this.currentPageInfo =
        'Showing 1 - ' +
        this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  getDate(date: Date): Date {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  }

  getEventSheduleHeaderFilelds() {
    this.selectedProgramGuid = this.getProgramTypeGuid();
    const programTypeConfig = eventNewPaymentBatch.program.find(
      obj => obj.programTypeGuid === this.selectedProgramGuid
    );

    this.engagementId =
      programTypeConfig?.element.find(
        obj => obj.id === 'engagementRegistrationId'
      )?.displayName || '';
    this.engagementName =
      programTypeConfig?.element.find(obj => obj.id === 'engagementName')
        ?.displayName || '';
    this.engagementSubType =
      programTypeConfig?.element.find(obj => obj.id === 'engagementSubType')
        ?.displayName || '';
  }

  onConfirm() {
    this.loading = true;
    this.isBatchEventsDeletedConfirmation = false;
    this.isSubmit = true;
    this.onSubmit();
  }

  onCancel() {
    this.isBatchEventsDeletedConfirmation = false;
    this.loading = false;
  }
  getProgramTypeGuid() {
    return history.state.programTypeGuid
      ? history.state.programTypeGuid
      : ProgramTypesGUID.Events;
  }
}
